import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import CartList from "../../Components/CartList/CartList";
import Footer from "../../Components/Common/Footer";


class CartListPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <CartList />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default CartListPage;
